// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__eEgnb","total":"Header_total__3CIKa","green":"Header_green__1edKo","red":"Header_red__2uCzA"};